export default __webpack_public_path__ + "static/GraphikLCWeb-RegularItalic-0a4e942b08595c46b2801d791ae673de.woff";